import Header from '@/components/elements/Header/Header';
import ListItem from '@/components/elements/lists/ListItem/ListItem';
import ListItemContent from '@/components/elements/lists/ListItemContent/ListItemContent';
import Icon from '@/components/icons/Icon';
import { _s } from '@/locale';
import { toast } from 'react-toastify';
import Snackbar from '@/components/elements/notifications/Snackbar/Snackbar';
import { promiseWrapper } from '@/helpers';
import { updateProfileResponseSchema } from '@/types/api/services/user';
import { userService } from '@/services';
import { useAppSelector } from '@/hooks';
import { useDispatch } from 'react-redux';
import { userActions } from '@/actions';

const UpdateAccountProtection = () => {
  const user = useAppSelector((state) => state.users?.user);
  const forceLoginCheckbox = user?.about?.accountProtected ?? false;
  const appDispatch = useDispatch();
  const baseTranslationKey = 'account-settings';

  const handleAccountProtectedChange = async () => {
    const { data } = await promiseWrapper(
      userService.updateProfile({ about: { accountProtected: !forceLoginCheckbox } }),
    );

    const validatedResponse = updateProfileResponseSchema.safeParse(data);

    if (!validatedResponse.success) {
      toast(({ closeToast }) => (
        <Snackbar type="danger" label={_s(`${baseTranslationKey}.forceLogin.error`)} onClose={closeToast} />
      ));
      return;
    }

    toast(({ closeToast }) => (
      <Snackbar
        type="success"
        label={_s(
          `${baseTranslationKey}.forceLogin.${!forceLoginCheckbox ? 'successForceLogin' : 'successNotForceLogin'}`,
        )}
        onClose={closeToast}
      />
    ));
    // @ts-ignore
    appDispatch(userActions.updateUser({ ...user, ...validatedResponse.data }));
  };

  return (
    <div className="pr-lg">
      <div className="p-lg">
        <Header label={_s(`${baseTranslationKey}.forceLogin.section`)} size="lg" />
      </div>
      <ListItem
        verticalAlign="top"
        className="bg-primary-200 p-md rounded-sm"
        onClick={handleAccountProtectedChange}
        leftSlot={<Icon variant={forceLoginCheckbox ? 'checkbox-checked-filled' : 'square'} color="brand-500" />}>
        <ListItemContent
          subTitle={
            <span className="text-black-900 text-m">
              {_s(`account-settings.forceLogin.label`)}
              <br />
              {user.contact?.email}
            </span>
          }
        />
      </ListItem>
    </div>
  );
};

export default UpdateAccountProtection;
